import { Helmet } from "react-helmet";
import "../Analytics/styles.scss"

export const Analytics = (props: any) => {
   
    const getPageUrl = (): string => {
        const domain = window.location.origin;
        const pathname = window.location.pathname.toLowerCase();
        return `${domain}${pathname}`;
    };

    const attachDigitalData = (props: any): any => {
        const {
            siteName,
            siteCountry,
            siteLanguage,
            pageName,
            siteSection,
        } = props.data;
        const currentPageUrl = getPageUrl();
        const getPageDigitalData = {
            page: {
                pageInfo: {
                    pageUrl: currentPageUrl,
                    pageCleanUrl: window.location.href.replace(window.location.search+window.location.hash,'').replace(window.location.protocol+'//',''),
                    pageName,
                    siteName,
                    siteSection,
                    siteCountry,
                    siteLanguage
                },
            }
        }

        window.adobeDataLayer = getPageDigitalData;

    }
    
    return (
        <>
     <Helmet>
        <script type="text/javascript" >{`
        (function (id) {
        function append(scriptid, url, async) {
            var d = document, sn = 'script', f = d.getElementsByTagName(sn)[0];
            if (!f) f = d.head;
            var s = d.createElement(sn);
            s.async = async;
            s.id = scriptid;
            s.src = url;
            s.charset = 'utf-8';
            f.parentNode.insertBefore(s, f);
        }

        function is2parttld(value) {
            var tldindicators = ['co', 'com', 'info', 'web', 'info', 'gov', 'edu', 'biz', 'net', 'org'];
            var countryindicators = ['uk', 'us', 'fr', 'es', 'de', 'at', 'au', 'ae', 'be', 'br', 'ca', 'ch', 'cn', 'co', 'cz', 'dk', 'eg', 'eu', 'fi', 'gb', 'gr', 'hk', 'hr', 'hu', 'ie', 'in', 'jp', 'mx', 'nl', 'no', 'nz', 'pl', 'ro', 'ru', 'se'];
            return (tldindicators.indexOf(value) !== -1 || countryindicators.indexOf(value) !== -1);
        }

        function getRootDomain() {
            var parts = window.location.hostname.split('.');
            if (parts.length === 2) rootDomain = parts[0];
            else if (parts.length > 2) {
                // see if the next to last value is a common tld
                var part = parts[parts.length - 2];
                if (is2parttld(part)) {
                    rootDomain = parts[parts.length - 3]; // go back one more
                }
                else {
                    rootDomain = part;
                }
            }

            return rootDomain;
        }

        window.evidon = {};
        window.evidon.id = id;
        window.evidon.test = false;  // set to true for non-production testing.
        //window.evidon.userid = '';

        var cdn = '//c.evidon.com/', rootDomain = getRootDomain(), noticecdn = cdn + 'sitenotice/';
        append('evidon-notice', noticecdn + 'evidon-sitenotice-tag.js', false);
        append('evidon-location', cdn + 'geo/country.js', true);
        append('evidon-themes', noticecdn + id + '/snthemes.js', true);
        if (rootDomain) append('evidon-settings', noticecdn + id + '/' + rootDomain + (window.evidon.test ? '/test' : '') + '/settingsV2.js', true);

        window.evidon.handleAnalyticsProvider = function () {
            // Inject Adobe Analytics script
            var adobeScript = document.createElement('script');
            adobeScript.src = "${props.data.analyticsScriptPath}";
            adobeScript.async = true;
            adobeScript.onload = function () {
            console.log("Adobe Analytics loaded after consent");
            };
            document.head.appendChild(adobeScript);
             (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
                    var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
                    j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
                    f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer', 'GTM-W4V7GZG');
        }
         
        window.evidon.priorConsentCallback = function (categories, vendors, cookies) {
            var handlers = {
                'analytics': 'handleAnalyticsProvider',
                'marketing and personalization': 'handleMarketingPerformance'
            };
            if (!!categories['all']) {
                var handler = window.evidon.allProvider;
                if (typeof handler === 'function') handler();
                return;
            }
            for (var category in categories) {
                if (!categories[category]) continue;
                var handler = window.evidon[handlers[category]];
                if (typeof handler === 'function') handler();
            }
        }

        window.evidon.closeCallback = function () {
            // this is executed if the user closed a UI element without either Accepting (providing consent)
            // or Declining (declining to provide consent).
        }

        window.evidon.consentWithdrawnCallback = function () {
            // this is exeucted if the user withdraws consent and elects to
            // no longer allow technologies to run on the site.
        }

        window.evidon.handleChatConsent = function () { 
            // Baidu Analytics
            var baiduScript = document.createElement('script');
            baiduScript.src = 'https://hm.baidu.com/hm.js?c7de9e5c93666b1c6374db8b1c494403';  
            baiduScript.onload = function () {
                console.log("Baidu Analytics loaded after consent");
            };
            document.head.appendChild(baiduScript);
        }
        
        window.evidon.handleMarketingPerformance = function () {
            window.evidon.handleChatConsent();
        }

        window.evidon.allProvider = function () {
            window.evidon.handleAnalyticsProvider();
            window.evidon.handleMarketingPerformance();
        }

        window.evidon.consentDeclinedCallback = function () {
	    // this is executed if the user explicitly declines giving consent by
            // using a Decline button
            window.evidon.notice.dropSuppressionCookie(365); // 365 days
        }

        let styleTag = document.createElement('style');
        styleTag.type = 'text/css';
        styleTag.textContent = '.slideron{ background-color: #6022A6 !important; }' + '.evidon-prefdiag-message a{ color: #6022A6 !important; }';
        document.head.appendChild(styleTag);

    })(8523); `}</script>
    </Helmet>
    {attachDigitalData(props)}
    </>
  );
}

export default Analytics;